import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_data_table, {
      items: _ctx.chats,
      "item-value": "groupChatId",
      headers: _ctx.headers,
      "hide-default-footer": "",
      "no-data-text": "データはありません",
      loading: _ctx.loading,
      color: "primary"
    }, {
      "item.chatReadCount": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(item.chatReadCount + '人'), 1)
      ]),
      "item.edit": _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          onClick: ($event: any) => (_ctx.clickItem(item)),
          color: "primary",
          variant: "flat",
          size: "small"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("詳細 ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      "item.delete": _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          onClick: ($event: any) => (_ctx.clickDelete(item)),
          color: "error",
          variant: "outlined",
          size: "small"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("削除 ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["items", "headers", "loading"])
  ]))
}